module.exports = "/static/assets/2ab79ba84edfbe96e42aeef5611f4d83.png";